import { goClient, goRequest } from '../utils/httpClientTs';

export interface YearbookSection {
  id: string;
  key: string;
  name: string;
  description: string;
  default_sort_order: number;
  selected: boolean;
  sort_order?: number;
}

export interface YearbookLayout {
  membership_year: string;
  sections: YearbookSection[];
}

export const getYearbookLayout = (
  chapterId: string
): Promise<YearbookLayout> => {
  return goRequest<YearbookLayout>({
    url: `/membership/local_chapters/${chapterId}/yearbook`,
    method: 'GET',
  });
};

export const saveYearbookLayout = (
  chapterId: string,
  sectionIds: string[]
): Promise<YearbookLayout> => {
  return goRequest<YearbookLayout>({
    url: `/membership/local_chapters/${chapterId}/yearbook`,
    method: 'PUT',
    data: {
      sections: sectionIds.map((section_id, index) => ({
        section_id,
        sort_order: index + 1,
      })),
    },
  });
};

export const downloadYearbookPDF = async (chapterId: string): Promise<Blob> => {
  const response = await goClient.get<Blob>(
    `/membership/local_chapters/${chapterId}/yearbook.pdf`,
    { responseType: 'blob', timeout: 120000 }
  );
  return response.data;
};
